<template>
    <group-details :groupId="props.groupId">
        <contact-list :groupId="props.groupId" withoutOverview embedded></contact-list>
    </group-details>
</template>

<script setup>
import GroupDetails from './GroupDetails.vue';
import ContactList from '~/components/contacts/contact/ContactList.vue';

const props = defineProps({
    groupId: {
        type: String,
        required: true,
    }
});
</script>
